import { render, staticRenderFns } from "./sizeRuleModal.vue?vue&type=template&id=6ccc57e4&scoped=true"
import script from "./sizeRuleModal.vue?vue&type=script&lang=js"
export * from "./sizeRuleModal.vue?vue&type=script&lang=js"
import style0 from "./sizeRuleModal.vue?vue&type=style&index=0&id=6ccc57e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccc57e4",
  null
  
)

export default component.exports